import React from "react";

const SortChevron = ({ width = 12, height = 6, fill = "#AAAAAA", rotate = 0 }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 12 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{ rotate: `${rotate}deg` }}
		>
			<path d="M0.666016 0.666992L5.99935 6.00033L11.3327 0.666992H0.666016Z" fill={fill} />
		</svg>
	);
};

export default React.memo(SortChevron);
